import styled from 'styled-components';

import boldIcon from '../../assets/wysiwyg-icons/bold.svg';
import italicIcon from '../../assets/wysiwyg-icons/italic.svg';
import underlineIcon from '../../assets/wysiwyg-icons/underline.svg';
import listIcon from '../../assets/wysiwyg-icons/list.svg';
import numberListIcon from '../../assets/wysiwyg-icons/list-1.svg';
import linkIcon from '../../assets/wysiwyg-icons/link.svg';
import unLinkIcon from '../../assets/wysiwyg-icons/unlink.svg';
import emojiIcon from '../../assets/wysiwyg-icons/emoji.svg';
import imageIcon from '../../assets/wysiwyg-icons/image.svg';

export const Container = styled.div`
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};

  .rdw-image-modal-size {
    display: none;
  }

  .rdw-image-modal-upload-option-label {
    text-align: center;
  }

  .rdw-image-modal-header-option {
    display: none;
    width: 100%;
    text-transform: uppercase;
  }

  .rdw-image-modal-header-label-highlighted {
    background: none;
  }

  .rdw-image-modal-btn-section {
    display: flex;
    margin: .5rem 0 0 0;
    justify-content: center;
  }

  .rdw-image-modal-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 1.15rem .4rem;
    font-weight: bold;
    align-items: center;
    font-size: 1rem;
    transition: all .3s ease-in-out;
    text-transform: uppercase;
    width: 100%;
    border-color: none;

    &:hover {
      box-shadow: none;
    }
  }

  .rdw-image-modal-btn:nth-child(1) {
    background: #6e61c6;
    color: #fff;
    border: none !important;
  }

  .rdw-image-modal-btn:nth-child(2) {
    background: #dd3b3b;
    color: #fff;
    border: none;
    font-size: 12px;
  }

  .rdw-image-modal-btn:disabled {
    background: #ccc;
    color: #fff;
    border: none;
    cursor: not-allowed;
    font-size: 12px;
  }

  .rdw-image-modal-upload-option-label {
    color: ${props => props.theme.colors.white};
    width: 100%;
    font-weight: 400;
  }

  .rdw-image-modal-header {
    display: none;
  }

  .rdw-image-modal-header-option {
    width: 100%;
    font-weight: bold;
    text-transform: uppercase;
  }

  .public-DraftEditor-content[contenteditable=true] {
    color: ${props => props.theme.colors.white};
  }
  .rdw-image-modal {
    background: ${props => props.theme.cards.primary};
    color: ${props => props.theme.colors.white};
  }

  .rdw-image-modal-upload-option {
    background: ${props => props.theme.cards.primary};
    outline: 2px dashed #adafca;
  }

  .public-DraftEditorPlaceholder-root {
    color: #adafca;
    font-weight: 600;
    position: absolute;
    z-index: 0;
  }
  .DraftEditor-root {
    padding: 1.5rem 1.5rem;
    min-height: 200px;
    overflow-y: scroll;
    max-height: 200px;
    cursor: text;

    &::-webkit-scrollbar {
      visibility: hidden;
      width: 4px;
      height: 4px;
    }

    &:hover::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      opacity: 1;
      transition: all .3s ease-in-out;
    }

    &:hover::-webkit-scrollbar-thumb {
      background: #cccccc80;
      border-radius: 10px;
    }
    &:hover::-webkit-scrollbar-thumb:hover{

    }
    &:hover::-webkit-scrollbar-track{
      border-radius: 10px;
      box-shadow: inset 7px 10px 12px #cccccc10;
    }
  }
  .DraftEditor-editorContainer {
    margin-top: -1rem;
    font-weight: 600;
  }

  .public-DraftEditor-content[contenteditable=true] {
    color: ${props => props.theme.colors.white};
  }

  .rdw-editor-toolbar {
    border: none;
  }

  .rdw-option-wrapper {
    border: none;
    padding: 10px;
    border-radius: 50%;
    margin: 0 4px;
    display: flex;
    height: auto;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: transparent;
    text-transform: capitalize;
    transition: all .3s ease-in-out;

    &:hover {
      background: #c0c2d650;
      box-shadow: none;
    }
  }

  .public-DraftStyleDefault-block {
    margin: 0;
    font-weight: 400;
  }

  .public-DraftEditorPlaceholder-inner {
    margin-top: -1rem !important;
    font-weight: 400;
  }

  .editorClassName2, .toolbarClassName2 {
    background: ${props => props.theme.cards.primary};
    margin-bottom: 0;
    padding-top: 8px;
  }

  .rdw-emoji-modal, .rdw-link-modal, .rdw-image-modal {
   

    border: none;
    top: 40px;
    left: 0px;
    border-radius: 8px;
    justify-content: space-between;
    border: 1px solid ${props => props.theme.cards.border};
    box-shadow: none !important;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &:hover::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      opacity: 1;
      transition: all .3s ease-in-out;
    }

    &:hover::-webkit-scrollbar-thumb {
      background: #cccccc80;
      border-radius: 10px;
    }
    &:hover::-webkit-scrollbar-thumb:hover{

    }
    &:hover::-webkit-scrollbar-track{
      border-radius: 10px;
      box-shadow: inset 7px 10px 12px #cccccc10;
    }
  }

  .rdw-inline-wrapper {
    > div {
      color: ${props => props.theme.colors.white};

     > img {
        display: none;
        border: none;
      }

      &:nth-of-type(1) {
        &:after {
            /* Bold */
            content: url(${boldIcon});
            height: 16px;
            width: 16px;
            filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
      &:nth-of-type(2) {
        &:after {
            /* Italic */
            content: url(${italicIcon});
            height: 16px;
            width: 16px;
            filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
      &:nth-of-type(3) {
        &:after {
            /* underline */
            content: url(${underlineIcon});
            height: 16px;
            width: 16px;
            filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
    }
  }

  .rdw-list-wrapper {

    > div {
      color: ${props => props.theme.colors.white};

     > img {
        display: none;
        border: none;
      }

      &:nth-of-type(1) {
        &:after {
          /* list nao numerada */
          content: url(${listIcon});
          height: 16px;
          width: 16px;
          filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
      &:nth-of-type(2) {
        &:after {
          /* list numerada */
          content: url(${numberListIcon});
          height: 16px;
          width: 16px;
          filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
    }
  }

  .rdw-link-wrapper {

    > div {
      color: ${props => props.theme.colors.white};

     > img {
        display: none;
        border: none;
      }

      &:nth-of-type(1) {
        &:after {
          /* list nao numerada */
          content: url(${linkIcon});
          height: 16px;
          width: 16px;
          filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
      &:nth-of-type(2) {
        &:after {
          /* list numerada */
          content: url(${unLinkIcon});
          height: 16px;
          width: 16px;
          filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
    }
  }

  .rdw-emoji-wrapper {

    > div {
      color: ${props => props.theme.colors.white};

     > img {
        display: none;
        border: none;
      }

      &:nth-of-type(1) {
        &:after {
          /* list nao numerada */
          content: url(${emojiIcon});
          height: 16px;
          width: 16px;
          filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
    }
  }

  .rdw-image-wrapper {

    > div {
      color: ${props => props.theme.colors.white};

     > img {
        display: none;
        border: none;
      }

      &:nth-of-type(1) {
        &:after {
          /* list nao numerada */
          content: url(${imageIcon});
          height: 16px;
          width: 16px;
          filter: ${props => props.theme.specific.svgFilterRecolor}; //https://codepen.io/sosuke/pen/Pjoqqp
        }
      }
    }
  }


  > header {
    display: flex;
    align-items: center;
    min-height: 82px;
    padding-left: 28px;
    background: ${props => props.theme.cards.tertiary};
    border-bottom: 1px solid ${props => props.theme.cards.border};
    border-radius: ${props => props.theme.radius.primary} ${props => props.theme.radius.primary} 0 0;

    > p {
      color: ${props => props.theme.colors.white};
      line-height: 1em;
      font-size: 1rem;
      font-weight: 700;
    }
  }

  > footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px;
    border-top: 1px solid ${props => props.theme.cards.border};
    color: ${props => props.theme.colors.white};

    div {

      > p {
        font-weight: 600;
        color: #adafca;
        font-size: 12px;
      }

      > button {

        &:disabled {
          cursor: not-allowed !important;
          background: red;
        }
      }
    }
  }
`;
